// extracted by mini-css-extract-plugin
export default {"form":"VRXjb0","message":"h8i6Dd","circle":"VRgCas","circle__check":"JEKN9V"};